import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import {
  newCheckInAction,
} from '../../actions/navigation';

import Header from '../../components/Header';
import Transition from '../../components/Transition';
import Progress from '../../components/Progress';
import Modal from '../../components/Modal';
import imgError from '../../assets/images/error.svg';
import { useConfig } from '../../config/ConfigContext';

const isProgressVisible = true;
const Redirection = (props) => {
  const config = useConfig();
  const { params, searchParams } = props;
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [uploadingPercentage, setUploadingPercentage] = useState('');
  const workflowType = get(params, 'workflowType') || 'text2apply';
  const key = searchParams.get('key');

  useEffect(() => {
    const { dispatch, navigate } = props;

    if (!key) {
      navigate('/');
    }

    dispatch(newCheckInAction({
      rawUrl: `${config.navigationUrl}/${workflowType}/redirection/token/${searchParams.get('token')}`,
      onUploadProgress: (progressEvent) => {
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
      success: (res) => {
        navigate(get(res, 'data.url'));
      },
      fail: (error) => {
        setHasError(true);
        setErrorMessage(get(error, 'response.data.message', 'Internal server error'));
      },
    }));
  }, []);

  return (
    <Transition className="transition-item wrapper v-center">
      <Header />
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
      {
        hasError
          && (
          <Modal>
            <div className="card-content error-modal security-error">
              <img src={imgError} alt="error" />
              <p>{errorMessage}</p>
            </div>
          </Modal>
          )
      }
    </Transition>
  );
};

Redirection.propTypes = {
  navigate: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(Redirection);
